<script lang="ts" setup>
const props = defineProps<{
  value: any
}>()

const iconName = computed(() => props.value ? 'outlined/check-circle' : 'outlined/cancel')
const className = computed(() => props.value ? 'text-main-green' : 'text-main-red')
</script>

<template>
  <SvgIcon :class="className" :name="iconName" />
</template>
